/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



// === NOMADI FINANCING LOGO SIZE OVERRIDE ===
(function() {
  var s = document.createElement('style');
  s.id = 'nomadi-finance-logo-overrides';
  s.textContent = '#nomadi-financing-bar img, .nomadi-financing-bar img, .nomadi-floating-finance img, #nomadi-floating-finance img, .nomadi-card-finance img, .nomadi-financing-bar__logo-img, .nomadi-financing-bar__partner-img { max-width: 80px !important; max-height: 26px !important; width: auto !important; height: auto !important; object-fit: contain !important; display: block !important; } .nomadi-floating-finance img, #nomadi-floating-finance img { max-width: 55px !important; max-height: 16px !important; } .nomadi-card-finance img { max-width: 40px !important; max-height: 12px !important; } #nomadi-financing-bar a, .nomadi-floating-finance a, #nomadi-floating-finance a, .nomadi-financing-bar__partner-logos, .nomadi-financing-bar__partner-link, .nomadi-financing-bar__logo-link { display: inline-flex !important; align-items: center !important; flex-shrink: 0 !important; }';
  document.head.appendChild(s);
})();
